// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as AccountabilityRouteImport } from './routes/accountability'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AnswersRouteImport } from './routes/answers'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BookmarksRouteImport } from './routes/bookmarks'
import { Route as CommunityGuidelinesRouteImport } from './routes/community-guidelines'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DataUseRouteImport } from './routes/data-use'
import { Route as DiscussionsRouteImport } from './routes/discussions'
import { Route as EmergencyRouteImport } from './routes/emergency'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as HealthRouteImport } from './routes/health'
import { Route as ImpactRouteImport } from './routes/impact'
import { Route as IntelligenceRouteImport } from './routes/intelligence'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as LensRouteImport } from './routes/lens'
import { Route as MapRouteImport } from './routes/map'
import { Route as NearbyRouteImport } from './routes/nearby'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PulseRouteImport } from './routes/pulse'
import { Route as QuestionsRouteImport } from './routes/questions'
import { Route as ReportRouteImport } from './routes/report'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SolutionistsRouteImport } from './routes/solutionists'
import { Route as SpacesRouteImport } from './routes/spaces'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TrendsRouteImport } from './routes/trends'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as WorkspaceRouteImport } from './routes/workspace'
import { Route as CommunitiesIndexRouteImport } from './routes/communities.index'
import { Route as CommunitiesSlugRouteImport } from './routes/communities.$slug'
import { Route as FollowersUsernameRouteImport } from './routes/followers.$username'
import { Route as FollowingUsernameRouteImport } from './routes/following.$username'
import { Route as ImpactIndexRouteImport } from './routes/impact.index'
import { Route as MessagesIndexRouteImport } from './routes/messages.index'
import { Route as MessagesIdRouteImport } from './routes/messages.$id'
import { Route as PostsIdRouteImport } from './routes/posts.$id'
import { Route as ProfileUsernameRouteImport } from './routes/profile.$username'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as ProjectsIdRouteImport } from './routes/projects.$id'
import { Route as ImpactProjectsIndexRouteImport } from './routes/impact.projects.index'
import { Route as ImpactProjectsIdRouteImport } from './routes/impact.projects.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const AccountabilityRoute = AccountabilityRouteImport.update({
            id: '/accountability',path: '/accountability',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AnswersRoute = AnswersRouteImport.update({
            id: '/answers',path: '/answers',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BookmarksRoute = BookmarksRouteImport.update({
            id: '/bookmarks',path: '/bookmarks',getParentRoute: () => rootRouteImport
          })
const CommunityGuidelinesRoute = CommunityGuidelinesRouteImport.update({
            id: '/community-guidelines',path: '/community-guidelines',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DataUseRoute = DataUseRouteImport.update({
            id: '/data-use',path: '/data-use',getParentRoute: () => rootRouteImport
          })
const DiscussionsRoute = DiscussionsRouteImport.update({
            id: '/discussions',path: '/discussions',getParentRoute: () => rootRouteImport
          })
const EmergencyRoute = EmergencyRouteImport.update({
            id: '/emergency',path: '/emergency',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const HealthRoute = HealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => rootRouteImport
          })
const ImpactRoute = ImpactRouteImport.update({
            id: '/impact',path: '/impact',getParentRoute: () => rootRouteImport
          })
const IntelligenceRoute = IntelligenceRouteImport.update({
            id: '/intelligence',path: '/intelligence',getParentRoute: () => rootRouteImport
          })
const LeaderboardRoute = LeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => rootRouteImport
          })
const LensRoute = LensRouteImport.update({
            id: '/lens',path: '/lens',getParentRoute: () => rootRouteImport
          })
const MapRoute = MapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => rootRouteImport
          })
const NearbyRoute = NearbyRouteImport.update({
            id: '/nearby',path: '/nearby',getParentRoute: () => rootRouteImport
          })
const NotificationsRoute = NotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PulseRoute = PulseRouteImport.update({
            id: '/pulse',path: '/pulse',getParentRoute: () => rootRouteImport
          })
const QuestionsRoute = QuestionsRouteImport.update({
            id: '/questions',path: '/questions',getParentRoute: () => rootRouteImport
          })
const ReportRoute = ReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SigninRoute = SigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SolutionistsRoute = SolutionistsRouteImport.update({
            id: '/solutionists',path: '/solutionists',getParentRoute: () => rootRouteImport
          })
const SpacesRoute = SpacesRouteImport.update({
            id: '/spaces',path: '/spaces',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TrendsRoute = TrendsRouteImport.update({
            id: '/trends',path: '/trends',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const WorkspaceRoute = WorkspaceRouteImport.update({
            id: '/workspace',path: '/workspace',getParentRoute: () => rootRouteImport
          })
const CommunitiesIndexRoute = CommunitiesIndexRouteImport.update({
            id: '/communities/',path: '/communities/',getParentRoute: () => rootRouteImport
          })
const CommunitiesSlugRoute = CommunitiesSlugRouteImport.update({
            id: '/communities/$slug',path: '/communities/$slug',getParentRoute: () => rootRouteImport
          })
const FollowersUsernameRoute = FollowersUsernameRouteImport.update({
            id: '/followers/$username',path: '/followers/$username',getParentRoute: () => rootRouteImport
          })
const FollowingUsernameRoute = FollowingUsernameRouteImport.update({
            id: '/following/$username',path: '/following/$username',getParentRoute: () => rootRouteImport
          })
const ImpactIndexRoute = ImpactIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ImpactRoute
          })
const MessagesIndexRoute = MessagesIndexRouteImport.update({
            id: '/messages/',path: '/messages/',getParentRoute: () => rootRouteImport
          })
const MessagesIdRoute = MessagesIdRouteImport.update({
            id: '/messages/$id',path: '/messages/$id',getParentRoute: () => rootRouteImport
          })
const PostsIdRoute = PostsIdRouteImport.update({
            id: '/posts/$id',path: '/posts/$id',getParentRoute: () => rootRouteImport
          })
const ProfileUsernameRoute = ProfileUsernameRouteImport.update({
            id: '/profile/$username',path: '/profile/$username',getParentRoute: () => rootRouteImport
          })
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => rootRouteImport
          })
const ProjectsIdRoute = ProjectsIdRouteImport.update({
            id: '/projects/$id',path: '/projects/$id',getParentRoute: () => rootRouteImport
          })
const ImpactProjectsIndexRoute = ImpactProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => ImpactRoute
          })
const ImpactProjectsIdRoute = ImpactProjectsIdRouteImport.update({
            id: '/projects/$id',path: '/projects/$id',getParentRoute: () => ImpactRoute
          })





const ImpactRouteChildren = {
  ImpactIndexRoute: ImpactIndexRoute,ImpactProjectsIdRoute: ImpactProjectsIdRoute,ImpactProjectsIndexRoute: ImpactProjectsIndexRoute
}

const ImpactRouteWithChildren = ImpactRoute._addFileChildren(ImpactRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccessibilityRoute: AccessibilityRoute,AccountabilityRoute: AccountabilityRoute,AdminRoute: AdminRoute,AnswersRoute: AnswersRoute,AuthRoute: AuthRoute,BookmarksRoute: BookmarksRoute,CommunityGuidelinesRoute: CommunityGuidelinesRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,DashboardRoute: DashboardRoute,DataUseRoute: DataUseRoute,DiscussionsRoute: DiscussionsRoute,EmergencyRoute: EmergencyRoute,ForgotPasswordRoute: ForgotPasswordRoute,HealthRoute: HealthRoute,ImpactRoute: ImpactRouteWithChildren,IntelligenceRoute: IntelligenceRoute,LeaderboardRoute: LeaderboardRoute,LensRoute: LensRoute,MapRoute: MapRoute,NearbyRoute: NearbyRoute,NotificationsRoute: NotificationsRoute,OnboardingRoute: OnboardingRoute,PrivacyRoute: PrivacyRoute,PulseRoute: PulseRoute,QuestionsRoute: QuestionsRoute,ReportRoute: ReportRoute,ResetPasswordRoute: ResetPasswordRoute,SearchRoute: SearchRoute,SettingsRoute: SettingsRoute,SigninRoute: SigninRoute,SignupRoute: SignupRoute,SolutionistsRoute: SolutionistsRoute,SpacesRoute: SpacesRoute,TermsRoute: TermsRoute,TrendsRoute: TrendsRoute,UnsubscribeRoute: UnsubscribeRoute,VerifyEmailRoute: VerifyEmailRoute,WelcomeRoute: WelcomeRoute,WorkspaceRoute: WorkspaceRoute,CommunitiesSlugRoute: CommunitiesSlugRoute,FollowersUsernameRoute: FollowersUsernameRoute,FollowingUsernameRoute: FollowingUsernameRoute,MessagesIdRoute: MessagesIdRoute,PostsIdRoute: PostsIdRoute,ProfileUsernameRoute: ProfileUsernameRoute,ProjectsIdRoute: ProjectsIdRoute,CommunitiesIndexRoute: CommunitiesIndexRoute,MessagesIndexRoute: MessagesIndexRoute,ProjectsIndexRoute: ProjectsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)